export const environment = {
  production: false,
  api_url: 'https://dev-api.alphazed-alqosh.com',
  init_call: '/flare/boss/v2/init',
};
